import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Flex } from '../../../primitives/index.js';
export const TextWrapper = /*#__PURE__*/_styled(Flex, process.env.NODE_ENV === "production" ? {
  target: "evgrtsk0"
} : {
  target: "evgrtsk0",
  label: "TextWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1ff2wm5",
  styles: "position:relative;display:flex;flex-grow:1"
} : {
  name: "1ff2wm5",
  styles: "position:relative;display:flex;flex-grow:1/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRleHRXcmFwcGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV3QyIsImZpbGUiOiJUZXh0V3JhcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEZsZXggfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBUZXh0V3JhcHBlciA9IHN0eWxlZChGbGV4KSBgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1ncm93OiAxO1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVRleHRXcmFwcGVyLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});